import type { Supplier, SupplierForm } from '../../services/supplierService';

/**
 * ค่าฟอร์มผู้จำหน่าย — ตัวเดียวทั้งหน้าดู (อ่านอย่างเดียว) และหน้าเพิ่ม/แก้ไข
 * (แยกจาก SupplierPage เดิมที่เป็นโมดัล · มติ PO 28 ต.ค. 2026)
 */
export const emptySupplierForm = (code = ''): SupplierForm => ({
  code,
  name: '',
  contact_person: '',
  phone: '',
  email: '',
  address: '',
  tax_id: '',
  notes: '',
  is_active: true,
});

export const supplierToForm = (supplier: Supplier): SupplierForm => ({
  // BUG-S342-NULLCODE: code/name อาจเป็น null (supplier ที่ code ไม่ถูกกำหนด เช่น สร้างผ่าน API/import)
  // → guard `|| ''` เหมือน field อื่น กัน validate (`formData.code.trim()`) crash แล้ว save ล้มเงียบ
  code: supplier.code || '',
  name: supplier.name || '',
  contact_person: supplier.contact_person || '',
  phone: supplier.phone || '',
  email: supplier.email || '',
  address: supplier.address || '',
  tax_id: supplier.tax_id || '',
  notes: supplier.notes || '',
  is_active: supplier.is_active,
});

/** กติกาเดียวกับโมดัลเดิม (handleSave ของ SupplierPage) */
export const validateSupplierForm = (form: SupplierForm): Record<string, string> => {
  const errors: Record<string, string> = {};
  const code = form.code || '';
  const name = form.name || '';
  if (!code.trim()) {
    errors.code = 'กรุณาใส่รหัสผู้จำหน่าย';
  } else if (code.length < 2 || code.length > 50) {
    errors.code = 'รหัสผู้จำหน่ายต้องมีความยาว 2-50 ตัวอักษร';
  }
  if (!name.trim()) {
    errors.name = 'กรุณาใส่ชื่อผู้จำหน่าย';
  } else if (name.length < 2 || name.length > 200) {
    errors.name = 'ชื่อผู้จำหน่ายต้องมีความยาว 2-200 ตัวอักษร';
  }
  if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = 'รูปแบบอีเมลไม่ถูกต้อง';
  }
  return errors;
};

/** BUG-S162-P1: token กันแก้ทับ — updated_at ที่โหลดมา (ไม่เคยแก้ = created_at แบบเดียวกับ backend) */
export const supplierIfMatch = (supplier: Supplier): string | undefined =>
  supplier.updated_at || supplier.created_at || undefined;

/** ป้ายฟิลด์ภาษาไทย (ไทม์ไลน์ประวัติกิจกรรม) */
export const SUPPLIER_FIELD_LABELS: Record<string, string> = {
  code: 'รหัสผู้จำหน่าย',
  name: 'ชื่อผู้จำหน่าย',
  contact_person: 'ผู้ติดต่อ',
  phone: 'เบอร์โทรศัพท์',
  email: 'อีเมล',
  address: 'ที่อยู่',
  tax_id: 'เลขประจำตัวผู้เสียภาษี',
  notes: 'หมายเหตุ',
  is_active: 'สถานะ',
};
